import React, { useRef } from 'react'
import AwsConfig from '../../Config/AwsConfig'

const Draganddrop = props => {
  const {
    // truevalue,;
    sendtruevalue,
    sendEditmode,
    castas,
    sendcasten,
    editmode,
    sendCastTe,
    castaste,
    sendinputdata,
    sendcastCharacterTeValue,
    sendcastCharacterEnvalue,
    inputdata,
    casten,
    CastTe,
    castCharacterEn,
    castcharte,
    sendcastCharacterEn,
    sendcastcharte,
    sendcastenvalue,
    sendCastTeValue,
    // editData,
    // modeUrl,
    // active,
  } = props
  const dragItem = useRef()
  const dragOverItem = useRef()

  const dragStart = (e, position) => {
    dragItem.current = position
  }

  const dragEnter = (e, position) => {
    dragOverItem.current = position
    // console.log(e.target.innerHTML)
  }

  const drop = () => {
    sendtruevalue('cast', true)
    const copycastasItems = [...castas]
    const dragItemContent = copycastasItems[dragItem.current]
    copycastasItems.splice(dragItem.current, 1)
    copycastasItems.splice(dragOverItem.current, 0, dragItemContent)
    //
    const copycastasteItems = [...castaste]
    const dragItemContentte = copycastasteItems[dragItem.current]
    copycastasteItems.splice(dragItem.current, 1)
    copycastasteItems.splice(dragOverItem.current, 0, dragItemContentte)
    //
    const castenTemp = [...casten]
    const dragcasten = castenTemp[dragItem.current]
    castenTemp.splice(dragItem.current, 1)
    castenTemp.splice(dragOverItem.current, 0, dragcasten)
    sendcasten(castenTemp)
    //
    const castteTemp = [...CastTe]
    const dragcastte = castteTemp[dragItem.current]
    castteTemp.splice(dragItem.current, 1)
    castteTemp.splice(dragOverItem.current, 0, dragcastte)
    sendCastTe(castteTemp)
    //
    const castcharenTemp = [...castCharacterEn]
    const dragcastcharen = castcharenTemp[dragItem.current]
    castcharenTemp.splice(dragItem.current, 1)
    castcharenTemp.splice(dragOverItem.current, 0, dragcastcharen)
    sendcastCharacterEn(castcharenTemp)
    //
    const castcharteTemp = [...castcharte]
    const dragcastcharte = castcharteTemp[dragItem.current]
    castcharteTemp.splice(dragItem.current, 1)
    castcharteTemp.splice(dragOverItem.current, 0, dragcastcharte)
    sendcastcharte(castcharteTemp)
    dragItem.current = null
    dragOverItem.current = null
    const inputdataTemp = { ...inputdata }
    inputdataTemp.Moviecast = copycastasItems
    inputdataTemp.Moviecastte = copycastasteItems
    sendinputdata(inputdataTemp)
  }

  const remove = (event, index) => {
    sendtruevalue('cast', true)
    const castasTemp = [...castas]
    const castasteTemp = [...castaste]
    castasTemp.splice(index, 1)
    castasteTemp.splice(index, 1)
    const inputdataTemp = { ...inputdata }
    inputdataTemp.Moviecast = castasTemp
    inputdataTemp.Moviecastte = castasteTemp
    sendinputdata(inputdataTemp)
    const castenTemp = [...casten]
    castenTemp.splice(index, 1)
    sendcasten(castenTemp)
    const castteTemp = [...CastTe]
    castteTemp.splice(index, 1)
    sendCastTe(castteTemp)
    const castcharenTemp = [...castCharacterEn]
    castcharenTemp.splice(index, 1)
    sendcastCharacterEn(castcharenTemp)
    const castcharteTemp = [...castcharte]
    castcharteTemp.splice(index, 1)
    sendcastcharte(castcharteTemp)
  }

  const editcast = (event, index) => {
    sendEditmode(false)
    sendtruevalue('cast', true)
    const castasTemp = [...castas]
    const castasteTemp = [...castaste]
    // console.log(castasTemp, castasteTemp, 'castas')
    const castcharenTemp = [...castCharacterEn]
    const castcharteTemp = [...castcharte]
    const castenTemp = [...casten]
    const castteTemp = [...CastTe]
    // console.log(castenTemp, castteTemp, 'castenTemp')
    sendcastenvalue(castenTemp[index])
    sendCastTeValue(castteTemp[index])
    // console.log(castenTemp[index], castteTemp[index])
    sendcastCharacterEnvalue(castcharenTemp[index])
    sendcastCharacterTeValue(castcharteTemp[index])
    console.log(castcharteTemp, index, 'castcharteTemp')
    castasTemp.splice(index, 1)
    castasteTemp.splice(index, 1)
    castenTemp.splice(index, 1)
    castteTemp.splice(index, 1)
    castcharenTemp.splice(index, 1)
    castcharteTemp.splice(index, 1)
    sendcasten(castenTemp)
    sendCastTe(castteTemp)
    sendcastCharacterEn(castcharenTemp)
    sendcastcharte(castcharteTemp)
    const inputdataTemp = { ...inputdata }
    inputdataTemp.Moviecast = castasTemp
    inputdataTemp.Moviecastte = castasteTemp
    sendinputdata(inputdataTemp)
  }

  const compare = (a, b) => {
    const isSameUser = (a, b) => a.name_En === b.name_En

    // Get items that only occur in the left array,
    // using the compareFunction to determine equality.
    const onlyInLeft = (left, right, compareFunction) =>
      left.filter(leftValue => !right.some(rightValue => compareFunction(leftValue, rightValue)))
    const onlyInA = onlyInLeft(a, b, isSameUser)
    const onlyInB = onlyInLeft(b, a, isSameUser)

    const result = [...onlyInA, ...onlyInB]
    // console.log(result, 'cast result')
    return result.length
  }

  const indication = props.modeUrl
    ? compare(props.editData.Moviecast, inputdata.Moviecast) === 0 || props.active.cast === 'TRUE'
      ? { borderColor: 'green' }
      : { borderColor: 'red' }
    : ''
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        border: '1px solid lightgray',
        ...indication,
      }}
      className='rounded'
    >
      {castas &&
        castas.map((item, index) => (
          <div
            onDragStart={e => dragStart(e, index)}
            onDragEnter={e => dragEnter(e, index)}
            onDragEnd={drop}
            key={index}
            draggable
            style={{ marginBottom: '10px' }}
          >
            <div
              style={{
                border: '1px solid black',
                borderRadius: '1rem',
                padding: '3px',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={event => {
                  if (editmode === true) {
                    editcast(event, index)
                  }
                }}
              >
                <div
                  style={{ marginRight: '10px' }} // Adjust margin right as needed
                >
                  {item.isAnonymous ? (
                    ''
                  ) : (
                    <img
                      style={{
                        width: '2rem',
                        height: '2rem',
                        borderRadius: '50%',
                      }} // Adjust width, height, and border radius as needed
                      src={AwsConfig.movieCdnUrl + item.posterURL}
                      // alt={item.name_En}
                    />
                  )}
                </div>
                <div style={{ flexGrow: 1 }}>
                  {' '}
                  {/* Allow the text to take remaining space */}
                  <span style={{ fontSize: '16px' }}>{item.role}</span>{' '}
                  {/* Adjust font size and weight as needed */}
                </div>
                {item.isAnonymous ? (
                  <span
                    style={{
                      color: 'white',
                      backgroundColor: 'gray',
                      fontSize: '8px',
                      position: 'absolute',
                      top: '0px',
                      right: '35px',
                    }}
                  >
                    Anonymous
                  </span>
                ) : (
                  ''
                )}
              </div>
              <button
                type='button'
                style={{
                  borderRadius: '50%',
                  padding: '5px 5px',
                  marginLeft: '10px',
                  height: '20px',
                  width: '20px',
                }} // Adjust padding, margin left, and button size as needed
                onClick={event => remove(event, index)}
              >
                <span style={{ position: 'relative', bottom: '10px', right: '1px' }}>x</span>
              </button>
            </div>
            {/* <div
              style={{
                margin: '5px',
                border: '1px solid black',
                padding: '2px',
                borderRadius: '1rem',
                display: 'flex',
              }}
            >
              <span
                onClick={event => {
                  if (editmode === true) {
                    editcast(event, index)
                  }
                }}
              >
                {console.log(item, 'role')}
                {item.role}
              </span>
              <button
                style={{ borderRadius: '1rem' }}
                onClick={event => remove(event, index)}
                type='button'
              >
                X
              </button>
            </div> */}
          </div>
        ))}
    </div>
  )
}

export default Draganddrop
